import { Building, Briefcase, Users, Shield } from 'lucide-react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Messages prédéfinis par défaut (fallback)
export const DEFAULT_MESSAGES = [
  { id: 'default-1', titre: 'Bienvenue standard', contenu: 'Bienvenue sur notre plateforme ! Nous sommes ravis de vous compter parmi nos membres.', role_cible: null },
  { id: 'default-2', titre: "Bienvenue COOPER'S", contenu: "Bienvenue dans le réseau COOPER'S ! En tant que partenaire, vous bénéficiez d'un accès privilégié à nos outils et services.", role_cible: 'cooper' },
  { id: 'default-3', titre: 'Bienvenue Expert', contenu: "Bienvenue ! Votre expertise est précieuse pour notre communauté. Vous avez accès à l'ensemble des dossiers techniques.", role_cible: 'expert' },
  { id: 'default-4', titre: 'Invitation urgente', contenu: 'Votre compte a été créé en urgence. Merci de vous connecter rapidement pour compléter votre profil.', role_cible: null },
  { id: 'default-5', titre: 'Nouveau partenariat', contenu: "Suite à notre échange, nous avons le plaisir de vous ouvrir un accès à notre plateforme. N'hésitez pas à nous contacter pour toute question.", role_cible: null }
];

// Rôles disponibles
export const ROLES = [
  { value: 'cooper', label: "COOPER'S", icon: Building, color: 'purple', description: 'Partenaire courtier' },
  { value: 'expert', label: 'EXPERT', icon: Briefcase, color: 'orange', description: 'Technique & Préventif' },
  { value: 'member', label: 'Membre', icon: Users, color: 'green', description: 'Adhérent' },
  { value: 'admin', label: 'Administrateur', icon: Shield, color: 'blue', description: 'Gestionnaire plateforme' }
];
